import { Component, OnInit } from '@angular/core';
import { ClaimService } from '../../services/claim.service';
import TableHeader from '../../../../common/interfaces/table/tableHeader';
import BaseListComponent from '../../../../common/components/base-list/base-list.component';
import Claim from '../../../../core/data/models/claim.model';
import { SwalService } from '../../../../common/services/swal.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { TableComponent } from '../../../../common/components/table/table.component';
import { TableContainerComponent } from '../../../../common/components/table-container/table-container.component';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import ProducerClientDto from '../../../../core/data/dtos/producer-client.dto';
import { ClientButtonComponent } from '../../../../common/components/client-button/client-button.component';
import { ClientSelectorComponent } from '../../../../common/components/client-selector/client-selector.component';
import { TableColumnDirective } from '../../../../common/directives/table-column.directive';
import { NgxMaskPipe } from 'ngx-mask';
import { policyMask } from '../../../../common/constants/masks';
import { DatePipe } from '@angular/common';
import { dateFormats } from '../../../../common/constants/dateFormats';
import { LocalPaginationService } from '../../../../common/services/local-pagination.service';

@Component({
  selector: 'app-claim-list',
  providers: [ClaimService, LocalPaginationService],
  imports: [
    TableComponent,
    TableContainerComponent,
    ClientButtonComponent,
    ClientSelectorComponent,
    TableColumnDirective,
    NgxMaskPipe,
    DatePipe,
  ],
  templateUrl: './claim-list.component.html',
  styleUrl: './claim-list.component.css',
})
export class ClaimListComponent
  extends BaseListComponent<Claim>
  implements OnInit
{
  client?: ProducerClientDto;
  override filterParams = ['policyNumber'];

  protected readonly policyMask = policyMask;
  protected readonly dateFormats = dateFormats;

  constructor(
    private claimService: ClaimService,
    private authService: AuthService,
    private router: Router,
    private swalService: SwalService,
  ) {
    super();
  }

  get tableHeaders() {
    const result: TableHeader[] = [
      {
        label: 'Reclamo',
        attribute: 'lossDate',
      },
      {
        label: 'Póliza',
        attribute: 'policyNumber',
      },
      {
        label: 'Responsable',
        attribute: 'responsible',
      },
      {
        label: 'Cantidad de lesionados',
        attribute: 'injuredQuantity',
      },
      {
        label: 'Dirección del accidente',
        attribute: 'lossAddress',
      },
      {
        label: 'Daños del vehículo',
        attribute: 'lossDescription',
      },
      {
        label: '¿Cómo ocurrió el accidente?',
        attribute: 'eventDescription',
        type: 'description',
      },
      {
        label: '',
        attribute: 'action',
      },
    ];

    return result;
  }

  get sortedData() {
    return this.filteredData.sort((a, b) => {
      const dateA = new Date(a.lossDate).getTime();
      const dateB = new Date(b.lossDate).getTime();
      return dateB - dateA; // Sort in descending order (most recent first)
    });
  }

  get isIntermediary() {
    return this.authService.isIntermediary;
  }

  get isClient() {
    return this.authService.isClient;
  }

  override ngOnInit(): void {
    this.swalService.showLoading();
    if (this.authService.user && !this.isIntermediary) {
      this.getClaims();
    }
  }

  async getClaims() {
    if (this.isIntermediary && !this.client) return;

    try {
      const result = await lastValueFrom(
        this.claimService.getMyClaims(
          this.isIntermediary
            ? this.client!.idnumber!
            : this.authService.user.idTokenClaims?.extension_IdNumber!,
        ),
      );
      this.data = result.data;
      this.swalService.dismiss();
    } catch (e) {
      console.log(e);
      this.swalService.dismiss();
    }
  }

  addClaim() {
    this.router.navigate(['/claims/create'], {
      queryParams: {
        client: this.isIntermediary ? this.client!.idnumber : null,
      },
    });
  }

  handleSelectedClient($event: ProducerClientDto) {
    this.client = $event;
    this.getClaims();
  }
}
